// local
import { sortData, mapById } from 'app/lib/helper';

const initialState = () => ({
    loading: false,
    returned: [],
    delivered: [],
    query: {},
    sort: {
        returned: {
            column: 'replacementConfirmed',
            direction: 'descending',
        },
        delivered: {
            column: 'replacementConfirmed',
            direction: 'descending',
        },
    },
});

const initItems = array =>
    array.map(item => {
        return {
            ...item,
            cylinderQtdConfirmedEdit: item.cylinderQtdConfirmed,
            isEdit: false,
            isSaved: false,
        };
    });

const ACTION_KEY = 'EDIT_CONFIRM_DELIVERY_DATA';

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                loading: true,
                query: action.payload,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            const { returned, delivered } = action.payload;
            return {
                ...state,
                loading: false,
                returned: initItems(sortData(returned, state.sort.returned)),
                delivered: initItems(sortData(delivered, state.sort.delivered)),
            };
        }
        case `${ACTION_KEY}_SORT`: {
            let { key, column, direction } = action.payload;
            const sort = { column, direction };
            const data = state[key];
            return {
                ...state,
                sort: {
                    ...state.sort,
                    [key]: sort,
                },
                [key]: sortData(data, sort),
            };
        }
        case `${ACTION_KEY}_EDIT_ROW`: {
            const { key, id, isEdit } = action.payload;
            return {
                ...state,
                [key]: mapById(state[key], id, item => {
                    return {
                        ...item,
                        isEdit,
                        isSaved: false,
                    };
                }),
            };
        }
        case `${ACTION_KEY}_SAVE_ROW`: {
            const { key, id } = action.payload;
            return {
                ...state,
                [key]: mapById(state[key], id, item => {
                    return {
                        ...item,
                        isEdit: false,
                        isSaved: true,
                    };
                }),
            };
        }
        case `${ACTION_KEY}_UPDATE_ROW`: {
            const { key, id, value } = action.payload;
            return {
                ...state,
                [key]: mapById(state[key], id, item => {
                    return {
                        ...item,
                        cylinderQtdConfirmedEdit: value,
                    };
                }),
            };
        }
        case `${ACTION_KEY}_CANCEL`: {
            return {
                ...state,
                returned: initItems(sortData(state.returned, state.sort.returned)),
                delivered: initItems(sortData(state.delivered, state.sort.delivered)),
            };
        }
        case `${ACTION_KEY}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
